import { useQuery, UseQueryResult } from "@tanstack/react-query";
import jwt_decode, { JwtPayload } from "jwt-decode";

import { customAxios } from "lib/axios";
import { User } from "types";
import storage from "utils/storage";

type Payload = JwtPayload & {
  _id: string;
};

const getUser = async (
  signal: AbortSignal | undefined,
  userIdFromParam?: string
): Promise<User | null> => {
  let userId = userIdFromParam;

  if (!userId) {
    const token = storage.getToken();
    if (!token) return null;

    const decoded = jwt_decode<Payload>(token);
    userId = decoded._id;
  }

  if (userId) {
    const { data } = await customAxios.get<User>(`/users/${userId}`, {
      signal,
    });
    return data;
  }

  return null;
};

export const useGetUserProfile = (userId?: string): UseQueryResult<User | null> =>
  useQuery<User | null>({
    queryKey: ["auth-user", userId],
    queryFn: ({ signal }) => getUser(signal, userId),
    staleTime: 0,
    retry: 1,
    refetchOnMount: "always",
    enabled: !!userId || !!storage.getToken(), // prevent running when nothing is available
  });
